import { atomWithObservable } from "jotai/utils";
import { Subject } from "rxjs";

export const globalStickyError$ = new Subject<{ message: string | null }>();
export const globalStickErrorStore = atomWithObservable(() => globalStickyError$, { initialValue: { message: null } });
